import React, { useState, useEffect } from 'react';
import styles from './Navbar.module.css';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`${styles.nav} ${isScrolled ? styles.navScrolled : ''}`}>
      <div className={styles.navContainer}>
        <a href="/" className={styles.logoLink}>
          <img
            src="/assets/loggableLogos/LoggableIconHorizontal.png"
            alt="Loggable Logo"
            className={`${styles.navLogo} ${styles.desktopLogo}`}
          />
          <img
            src="/assets/loggableLogos/LoggableIcon.png"
            alt="Loggable Mobile Logo"
            className={`${styles.navLogo} ${styles.mobileLogo}`}
          />
        </a>

        <button
          className={styles.loginButton}
          onClick={() => window.open('https://app.loggable.net', '_blank')}
        >
          <span className={styles.buttonText}>Login</span>
          <svg 
            className={styles.buttonIcon} 
            width="16" 
            height="16" 
            viewBox="0 0 16 16" 
            fill="none"
          >
            <path 
              d="M6 12L10 8L6 4" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>
    </nav>
  );
}